import ApiService from "@/utils/api.service";

export default {

    getMailings(context) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("mailing/list")
                .then(({ data }) => {
                    context.commit("setMailings", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },

    getMailchimpTemplates(context) {

        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("mailing/templates")
                .then(({ data }) => {
                    context.commit("setMailchimpTemplates", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },

    saveMailing(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("mailing/mail/" + params.id, params.model)
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    createMailing(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("mailing/mail", params.model)
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    }

}